import RequestErrorUtils, { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////////////////////

export const useAddPublicationToSeeLaterList = (): [React.Dispatch<React.SetStateAction<string | null>>, boolean] => {
    const api = useCoreApi();
    const { t } = useTranslation("knowledge");
    const { enqueueSnackbar } = useSnackbar();
    const [publicationId, addToSeeLater] = useState<string | null>(null);
    const [postingSeeLater, setPostingSeeLater] = useState<boolean>(false);

    useEffect(() => {
        if (publicationId != null) {
            setPostingSeeLater(true);

            api.v1.knowledgePublication.addToListSeeLater({ publicationId })
                .then(result => {
                    if (result.data)
                        enqueueSnackbar(t("Publication.ContentPage.AddToSeeLaterSuccessMessage"), { variant: "success" });
                    else
                        enqueueSnackbar(t("Publication.ContentPage.AddToSeeLaterErrorMessage"), { variant: "error" });
                })
                .catch(e => {
                    const errorMessage = RequestErrorUtils.findValidationMessage(e, "publicationId", "ListPublicationItemAlreadyExists");
                    if (errorMessage) enqueueSnackbar(errorMessage, { variant: "warning" });
                    else MprcRequestSnackbarErrorReport(e);
                })
                .finally(() => { setPostingSeeLater(false); addToSeeLater(null); });
        }
    }, [publicationId]);

    return [addToSeeLater, postingSeeLater];
};
